import { useEffect, useRef } from 'react';

import { isTrackedOutOfStockProductCode } from '../constants/trackedOutOfStockProductCodes';
import { logOutOfStockProductPageVisit } from '../utils/logOutOfStockProductPageVisit';

type ProductLike = {
    code: string;
    name: string;
};

type VariantLike = {
    code: string;
};

type Options = {
    productCode?: string;
    baseProduct?: ProductLike | null;
    productVariant?: VariantLike | null;
    isOutOfStock: boolean;
};

/**
 * Logs once per mount when the PDP URL slug matches a tracked product that is actually out of stock.
 * Waits for base product and variant so Datadog facets are complete.
 */
export const useLogOutOfStockProductPageVisit = ({
    productCode,
    baseProduct,
    productVariant,
    isOutOfStock,
}: Options) => {
    const hasLoggedVisitRef = useRef(false);

    useEffect(() => {
        if (!isTrackedOutOfStockProductCode(productCode) || !isOutOfStock || !baseProduct || !productVariant?.code) {
            return;
        }

        if (hasLoggedVisitRef.current) {
            return;
        }

        hasLoggedVisitRef.current = true;
        logOutOfStockProductPageVisit({
            productCode,
            baseProductCode: baseProduct.code,
            productName: baseProduct.name,
            variantCode: productVariant.code,
        });
    }, [baseProduct, isOutOfStock, productCode, productVariant]);
};
